import React from 'react'

const italicizeText = (text: any) => {
  let italicArray = text.split(/(_)/g)
  return italicArray.map((innerText: string, n: number) => {
    if (innerText === '_' && italicArray[n + 2] === '_') {
      let contentInsideIndicator = italicArray[n + 1]
      if (contentInsideIndicator.includes('~~')) {
        contentInsideIndicator = strikethroughText(contentInsideIndicator)
      }
      let italicItem = (
        <span className="InlineItalic" key={`InlineItalic-${n}`}>
          {contentInsideIndicator}
        </span>
      )
      italicArray.splice(n, 2)
      return italicItem
    } else {
      if (innerText.includes('~~')) {
        return strikethroughText(innerText)
      } else if (innerText !== '') {
        return innerText
      }
    }
  })
}

const strikethroughText = (text: string) => {
  let strikethroughArray = text.split(/(~~)/g)
  let elements: any = []
  for (let i = 0; i < strikethroughArray.length; i++) {
    let innerText = strikethroughArray[i]
    if (innerText === '~~' && strikethroughArray[i + 2] === '~~') {
      let contentInsideIndicator = strikethroughArray[i + 1]
      if (contentInsideIndicator.includes('_')) {
        contentInsideIndicator = italicizeText(contentInsideIndicator)
      }
      elements.push(
        <span className="InlineStrikethrough" key={`InlineStrikethrough-${i}`}>
          {contentInsideIndicator}
        </span>
      )
      i += 2
    } else {
      if (innerText.includes('_')) {
        elements.push(<span key={`strikethroughNormal--${i}`}>{italicizeText(innerText)}</span>)
      } else if (innerText !== '') {
        elements.push(<span key={`strikethroughNormal--${i}`}>{innerText}</span>)
      }
    }
  }
  return elements
}

const breakText = (text: string) => {
  const formattedText = text.split('<br>')
  return formattedText.map((item: any, i: number) => {
    let itemText = item
    if (item.includes('_')) {
      itemText = italicizeText(itemText)
    }
    if (item.includes('~~')) {
      itemText = strikethroughText(itemText)
    }
    return (
      <span
        key={`LineBreak-${i}`}
        className={formattedText.length === i + 1 ? `LineBreak inline-formatter` : `LineBreak`}>
        {itemText}
      </span>
    )
  })
}

const formatTextAccordingToIndicator = (text: string, indicators: string[]) => {
  let formats = []
  let elements = []
  let newString = ''

  for (let p = 0; p < indicators.length; p++) {
    const indicator = indicators[p]
    let splitText = text.split(indicator)

    let classOfIndicator
    if (indicator === '~~') {
      formats.push('~~')
      classOfIndicator = 'InlineStrikethrough'
    } else if (indicator === '_') {
      formats.push('_')
      classOfIndicator = 'InlineItalic'
    } else if (indicator === '<br>') {
      formats.push('<br>')
      classOfIndicator = 'LineBreak'
    }

    for (let i = 0; i < splitText.length; i++) {
      let innerText = splitText[i]

      if (innerText === indicator && splitText[i + 2] === indicator) {
        let innerElements = []
        let textWithinIndicator = splitText[i + 1]
        if (textWithinIndicator.includes('~~') || textWithinIndicator.includes('_')) {
        }
        for (let y = p; y < indicators.length; y++) {}
        elements.push(
          <span className={`${classOfIndicator}`} key={`${classOfIndicator}--${i}`}>
            {splitText[i + 1]}
          </span>
        )

        i += 2
      } else {
        elements.push(<span key={`NormalText-${i}`}>{innerText}</span>)
      }
    }
  }
  console.log(newString)
}

const boldText = (text: string) => {
  // the number 7 represents the length of <b></b>
  if (text.length < 7) return text
  let start = 0
  let end = text.length

  for (let i = 0; i < text.length - 2; i++) {
    if (text[i] + text[i + 1] === '<b') {
      start = i + 3
    } else if (text[i] + text[i + 1] === '/b') {
      end = i - 1
    }
  }

  const leftText = text.substring(0, start - 3)
  const boldedText = text.substring(start, end)
  const rightText = text.substring(end + 4)

  return (
    <>
      {leftText}
      <span className="boldText">{boldedText}</span>
      {rightText}
    </>
  )
}

const formatInlineCode = (text: string) => {
  if (text && typeof text === 'string' && text.includes('<br>')) {
    return breakText(text)
  } else if (text && typeof text === 'string' && text.includes('_')) {
    return italicizeText(text)
  } else if (text && typeof text === 'string' && text.includes('~~')) {
    return strikethroughText(text)
  } else if (text && typeof text === 'string' && text.includes('<b>')) {
    return boldText(text)
  } else {
    return text
  }
}

export const addClassToLastElementOfReadOnlyJSX = (
  formattedText: JSX.Element[],
  classToBeAdded: string
) => {
  if (Array.isArray(formattedText)) {
    const lastChild = formattedText.pop()
    if (lastChild && typeof lastChild == 'object') {
      const lastChildClassName = lastChild?.props?.className
      const lastChildFormatted = Object.assign({}, lastChild, {
        props: {
          ...lastChild?.props,
          className: `${lastChildClassName} ${classToBeAdded}`,
        },
      })
      formattedText.push(lastChildFormatted)
    }
  }
  return formattedText
}

export const addClassToFirstElementOfReadOnlyJSX = (
  formattedText: JSX.Element[],
  classToBeAdded: string
) => {
  if (Array.isArray(formattedText)) {
    const firstChild = formattedText[0]
    if (firstChild && typeof firstChild == 'object') {
      const firstChildClassName = firstChild?.props?.className
      const firstChildFormatted = Object.assign({}, firstChild, {
        props: {
          ...firstChild?.props,
          className: `${firstChildClassName} ${classToBeAdded}`,
        },
      })
      formattedText[0] = firstChildFormatted
    }
  }
  return formattedText
}

export default formatInlineCode
